import React from 'react';
import {Link} from 'react-router-dom';
import {Button, Card, Divider, Form, Input, Select, Table} from 'antd';
import {getJobs} from './JobAPI';

class Jobs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      jobLocations: [],
      jobFunctions: [],
      filteredJobs: [],
      isLoadingData: true
    };
  }

  mController = new AbortController();
  mSignal = this.mController.signal;

  componentDidMount = async () => {
    await getJobs({signal: this.mSignal}).then(response => {
      this.setState({
        jobs: response,
        filteredJobs: response,
        jobLocations: [...new Set(response.map(job => job.location))],
        jobFunctions: [...new Set(response.map(job => job.vacancyFunction.name))],
        isLoadingData: false
      });
    }).catch(() => {
      this.setState({
        isLoadingData: false
      });
    });
  };

  componentWillUnmount() {
    this.mController.abort();
  }

  handleFilterSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((error, formInput) => {
      if (error) {
        return;
      }

      let { keyword, location, jobFunction } = formInput;
      let { jobs } = this.state;

      if (location) {
        jobs = jobs.filter(job => job.location.toString().toLowerCase().includes(location.toLowerCase()));
      }

      if (jobFunction) {
        jobs = jobs.filter(job => job.vacancyFunction.name.toString().toLowerCase().includes(jobFunction.toLowerCase()));
      }

      this.setState({
        filteredJobs: jobs.filter(job => {
            return !keyword ? job : job.position.toString().toLowerCase().includes(keyword.toLowerCase())
              || job.location.toString().toLowerCase().includes(keyword.toLowerCase())
              || job.vacancyFunction.name.toString().toLowerCase().includes(keyword.toLowerCase());
        })
      });
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isLoadingData, jobLocations, jobFunctions, filteredJobs } = this.state;

    const columns = [{
      title: 'No.',
      dataIndex: 'orderNo',
      key: 'orderNo',
      align: 'center',
      width: 65
    }, {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      render: (text, job) => <Link to={`/jobs/${job.key}`}>{text}</Link>,
    }, {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
      align: 'center'
    }, {
      title: 'Job Function',
      dataIndex: 'jobFunction',
      key: 'jobFunction',
      align: 'center'
    }];

    const data = [];

    filteredJobs.forEach((job, index) => {
      const str = "" + (index + 1);
      const pad = "00";
      const orderNo = pad.substring(0, pad.length - str.length) + str;

      data.push(
        {
          key: job.id,
          orderNo,
          position: job.position,
          jobFunction: job.vacancyFunction.name,
          location: job.location
        }
      );
    });

    const formProps = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
        md: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      labelAlign: 'left',
      colon: false
    };

    return(
      <>
        <Card
          style={{height: 381, background: '#000000', backgroundImage: `url(${require('../assets/vacancy-banner.png')})`}}
        >
          <h1 style={{color: '#ffffff', fontSize: 24}}>Join Our Team</h1>
        </Card>
        <br />
        <h2 style={{color: '#55248A'}}>Our Vacancies</h2>
        <Form {...formProps} onSubmit={this.handleFilterSubmit}>
          <Form.Item label="Location">
            {getFieldDecorator('location', {initialValue: ""})(
              <Select>
                <Select.Option value="">All</Select.Option>
                {jobLocations.map(l => <Select.Option key={l}>{l}</Select.Option>)}
              </Select>
            )}
          </Form.Item>
          <Form.Item label="Job Function">
            {getFieldDecorator('jobFunction', {initialValue: ""})(
              <Select>
                <Select.Option value="">All</Select.Option>
                {jobFunctions.map(f => <Select.Option key={f}>{f}</Select.Option>)}
              </Select>
            )}
          </Form.Item>
          <Form.Item label="Keyword">
            {getFieldDecorator('keyword')(
              <Input />
            )}
          </Form.Item>
          <Form.Item wrapperCol={{xs: { span: 24 }, sm: { span: 8, offset: 3 }, md: { span: 8, offset: 2 }}}>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
          </Form.Item>
        </Form>
        <Divider />
        <Table
          columns={columns}
          bordered
          dataSource={data}
          pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['5', '10', '20', '30'] }}
          loading={isLoadingData}
        />

        <Divider/>
        <p style={{fontSize: 18}}>
          Mitrais only recruits online and maintains its online job advertisements through this Career Site and through job portals like JobStreet.com, Stackoverflow.com and Seek.com.au. Mitrais is not responsible for advertisements and recruitments by sources other than as stated herein.
        </p>

        <div style={{textAlign: 'center', fontSize: 25, color: '#55248A', marginBottom: 50}}>
          <p> Mitrais Recruitment Process:</p>
          <img src={require('../assets/recruitment-process.jpg')} alt="Flow Mitrais Recruitment Process" width="100%" style={{maxWidth:956}}/>
        </div>
        <p style={{fontSize: 18}}>
          Mitrais does not only conduct Equal Opportunity Employment but also strives to provide pleasant recruitment experience. Mitrais’ Recruiter will be more than happy to guide Candidates through each stage of the process and to answer any inquires that might arise during the process.
        </p>
      </>
    );
  }
}

export default Form.create({ name: 'filterJobs' })(Jobs);